import { Mappable} from "../../../_shared/mappable.class";
import { GraphBar } from "../../graph/GraphBar";
import { BarSegment } from "../../graph/BarSegment";
import { BreakdownType, Cue5050BaseReport } from "./Cue5050BaseReport";
import { DatePipe } from "@angular/common";

export class Cue5050PurchaseDetailsReport implements Mappable<Cue5050PurchaseDetailsReport>, Cue5050BaseReport{
    constructor(data: Partial<Cue5050PurchaseDetailsReport>) {
        Object.assign(this, data);
        this.datePipe = new DatePipe("en-US");
    }

    datePipe: DatePipe;

    cue5050Id: number;
    name: string;
    eventStartDate: Date;
    eventEndDate: Date;
    totalOrders: number;
    onlineOrders: number;
    cashOrders: number;
    cardOrders: number;
    stationOrderBreakdowns: StationOrderBreakdown[];
    pricingOrderBreakdowns: PricingTierOrderBreakdown[];

    getBarMappingsByBreakdownType(type: BreakdownType): GraphBar {
        if (type === BreakdownType.OrdersByPaymentMethod){
            return this.getOrdersByMethodMapping();
        }else if (type === BreakdownType.OrderByStation){
            return this.getOrdersByStationMapping();
        }else if (type === BreakdownType.OrdersByTicketTier){
            return this.getOrdersByTicketTierMapping();
        }
    }
    getBreakdownTypes(): BreakdownType[] {
        return [BreakdownType.OrdersByPaymentMethod, BreakdownType.OrderByStation, BreakdownType.OrdersByTicketTier];
    }
    getBreakdownByBreakdownType(type: BreakdownType): string[] {
        if (type === BreakdownType.OrdersByPaymentMethod){
            return ["Online Orders", "Cash Orders", "Card Orders"];
        }else if (type === BreakdownType.OrderByStation){
            return ["Online Orders"].concat(this.stationOrderBreakdowns.map(s => s.name));
        }else if (type === BreakdownType.OrdersByTicketTier){
            return this.pricingOrderBreakdowns.map(p => p.name);
        }
    }
    getYAxisName() {
        return 'Total Orders';
    }

    getXAxisName(){
        return 'Event Date';
    }

    getOrdersByMethodMapping(): GraphBar{
        return {
            name: this.datePipe.transform(this.eventStartDate),
            description: this.name,
            size: this.totalOrders,
            segments: [{name: 'Online Orders', size: this.onlineOrders}, 
                       {name: 'Cash Orders', size: this.cashOrders}, 
                       {name: 'Card Orders', size: this.cardOrders}]
        } as GraphBar
    }

    getOrdersByStationMapping(): GraphBar{
            return {
                name: this.datePipe.transform(this.eventStartDate),
                description: this.name,
                size: this.totalOrders,
                segments: [{name: "Online", size: this.onlineOrders}].concat(this.stationOrderBreakdowns.map(s => {
                    return {
                        name: s.name,
                        size: s.numberOfOrders
                    } as BarSegment
                }))
            } as GraphBar
    }

    getOrdersByTicketTierMapping(){
        return {
            name: this.datePipe.transform(this.eventStartDate),
            description: this.name,
            size: this.totalOrders,
            segments: this.pricingOrderBreakdowns.map(p => {
                return {
                    name: p.name,
                    size: p.numberOfOrders
                } as BarSegment
            })
        } as GraphBar
    }
}

export class StationOrderBreakdown{
    name: string;
    numberOfOrders: number;
}

export class PricingTierOrderBreakdown {
    name: string;
    numberOfOrders: number;
}